import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {DiDate} from 'app/blocks/util/di-date';

export interface IDriverStartDayLog extends IBaseEntity {
    id?: number;
    driverName?: string;
    startDateTime?: any;
    endDateTime?: any;
    numberOfStraps?: number;
    vehicleName?: string;
    trailerRef?: string;
    lengthOfDay?: number;
}

export class DriverStartDayLog extends BaseEntity implements IDriverStartDayLog {
    id: number;
    driverName: string;
    startDateTime: any;
    endDateTime: any;
    numberOfStraps: number;
    vehicleName: string;
    trailerRef: string;

    constructor(driverStartDayLog?) {
        super();
        if (driverStartDayLog) {
            this.id = driverStartDayLog.id;
            this.driverName = driverStartDayLog.driverName;
            this.startDateTime = DiDate.newInstance(driverStartDayLog.startDateTime);
            this.endDateTime = DiDate.newInstance(driverStartDayLog.endDateTime);
            this.numberOfStraps = driverStartDayLog.numberOfStraps;
            this.vehicleName = driverStartDayLog.vehicleName;
            this.trailerRef = driverStartDayLog.trailerRef;
        }
    }

    clone(): DriverStartDayLog {
        return new DriverStartDayLog(this);
    }

    get discriminator(): any {
        return this.id;
    }
}
